import type { RouteObject } from 'react-router';
import { AdminAiServicesPage } from '../pages/admin-ai-services-page';
import { AdminAiServiceDetailPage } from '../pages/admin-ai-service-detail-page';

export const adminAiServicesRoutes: RouteObject[] = [
  { path: 'ai-services', element: <AdminAiServicesPage /> },
  { path: 'ai-services/:serviceId', element: <AdminAiServiceDetailPage /> },
];
